// Moment
export const DATE_FORMAT = 'MMM D, YYYY'

// Form
export const MAX_UPLOAD_PAGES = 10
export const ACCEPTED_UPLOAD_TYPES = 'application/pdf'
export const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50MB
